import { createAsyncThunk } from '@reduxjs/toolkit'
import { sendTestWelcomeEmailMutation } from 'gql/publication/mutations'

export const sendTestWelcomeEmail = createAsyncThunk(
  'publication/sendTestWelcomeEmail',
  async ({ email, welcomeMessage }: { email: string; welcomeMessage: string }) => {
    await sendTestWelcomeEmailMutation(email, welcomeMessage)
  },
)
